import { ModeNames } from "@/modes/mode";
import { SupportedCamera, WalkOrbitControls } from "@faro-lotv/lotv";
import { create } from "zustand";
import { Projection } from "./ui/projection-switch";

export type LiveDraftTransitionStore = {
  /** The projection used in the previous view. */
  projection?: Projection;
  /** The camera used in the previous view. */
  camera?: SupportedCamera;
  /** The control object used in the previous view. */
  orbitControls?: WalkOrbitControls;

  /** Update the currently used camera. */
  setCamera(camera: LiveDraftTransitionStore["camera"]): void;
  /** Set the controls used in the ExplorationControl component. */
  setOrbitControls(
    orbitControls: LiveDraftTransitionStore["orbitControls"],
  ): void;
  /** Update the state based on the mode used in the Live view. */
  setFromLiveView(mode: ModeNames): void;
  /** Update the state based on the settings currently used in the Draft view. */
  setFromDraftSettings(
    projection: LiveDraftTransitionStore["projection"],
  ): void;
};

/**
 * A store holding state needed to make seamless transitions between Live and Draft view.
 */
export const useLiveDraftTransitionStore = create<LiveDraftTransitionStore>()(
  (set) => ({
    projection: undefined,
    camera: undefined,
    orbitControls: undefined,

    setFromLiveView: (mode) => {
      switch (mode) {
        case "walk":
        case "overview":
          set({
            projection: Projection.threeDimensional,
          });
          break;
        case "sheet":
        default:
          set({
            projection: Projection.twoDimensional,
          });
          break;
      }
    },

    setFromDraftSettings: (projection) => set({ projection }),

    setCamera: (camera) =>
      set({
        camera,
      }),

    setOrbitControls: (orbitControls) => set({ orbitControls }),

    clear: () =>
      set({
        projection: undefined,
        camera: undefined,
        orbitControls: undefined,
      }),
  }),
);
